import { render, staticRenderFns } from "./Faith.vue?vue&type=template&id=0ed26b3a&scoped=true&"
import script from "./Faith.vue?vue&type=script&lang=js&"
export * from "./Faith.vue?vue&type=script&lang=js&"
import style0 from "./Faith.vue?vue&type=style&index=0&id=0ed26b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed26b3a",
  null
  
)

export default component.exports